<template>
    <div>
        <dictionary-simple-table
        dictionary_link = "/product-erp-categories"
        title = "Lista kategorii produktu"
        :numeral_text = "['kategoria', 'kategorie', 'kategorii']"
        :columns_title = "['name']"
        ></dictionary-simple-table>
    </div>
</template>

<script>
    import DictionarySimpleTable from './DictionarySimpleTable.vue';
    export default {
        components: {
            DictionarySimpleTable
        },
    }
</script>